<template>
  <el-card class="box-card" shadow="always">
    <div slot="header" class="clearfix user-header">
      <span><i class="el-icon-user-solid"></i> {{$t('user.userInfo.user')}}</span>
      <span style="color: #409EFF">{{$t('user.userInfo.edit')}}</span>
    </div>
    <el-form :model="userForm" :rules="rules" ref="userForm" label-width="180px" class="demo-ruleForm">
      <el-form-item :label="$t('user.userInfo.form.username')" prop="username">
        <el-input size="small" v-model="userForm.username"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.email')" prop="email">
        <el-input size="small" v-model="userForm.email"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.password')" prop="password">
        <el-input size="small" v-model="userForm.password" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.role')" prop="role">
        <el-select v-model="userForm.role" size="small" placeholder="Роли">
          <el-option
            v-for="item in roles"
            :key="item.value"
            :label="item.title"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item :label="$t('user.userInfo.form.api')" prop="api_admin">-->
<!--        <el-select v-model="userForm.api_admin" size="small" placeholder="API">-->
<!--          <el-option-->
<!--            v-for="item in apiList"-->
<!--            :key="item.id"-->
<!--            :label="item.title"-->
<!--            :value="item.id">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item :label="$t('user.userInfo.form.group')" prop="group">
        <el-input size="small" v-model="userForm.group"></el-input>
      </el-form-item>
      <el-form-item label="Кол-во лент" prop="max_threads">
        <el-input size="small" v-model="userForm.max_threads" @input="handleChangeThreads"></el-input>
      </el-form-item>
      <el-form-item label="Лента по умолчанию" prop="default_thread_id" v-if="isAdmin">
        <el-input size="small" v-model="userForm.default_thread_id"></el-input>
      </el-form-item>
      <el-form-item label="Город" prop="map_center" v-if="isAdmin">
        <el-input size="small" v-model="userForm.map_center"></el-input>
      </el-form-item>
      <el-form-item class="manage" prop="manage_keywords" v-if="isAdmin">
        <el-checkbox v-model="userForm.manage_keywords" label="Доступ к редактированию ключевых слов"></el-checkbox>
        <el-checkbox v-model="isIaoApi" label="Доступ к обмену ИС ИАО"></el-checkbox>
        <el-checkbox v-model="userForm.b2b_user" label="Доступ к функционалу b2b"></el-checkbox>
        <el-button
          v-if="user.row.b2b_user"
          size="medium"
          type="primary"
          class="product-btn"
          @click="openModal()">Продукты
        </el-button>
      </el-form-item>
<!--      <el-form-item prop="api_admin" v-if="isAdmin">-->
<!--      </el-form-item>-->
      <el-divider></el-divider>
      <div class="user-card-footer">
        <el-button
          size="medium"
          type="success"
          @click="handleEdit('userForm')">Сохранить</el-button>
        <el-button
          size="medium"
          type="danger"
          @click="beforeDelete(user.$index, user.row)">Удалить</el-button>
      </div>
    </el-form>
    <el-dialog title="Продукты пользователя" :visible.sync="modalVisible">
        <el-button
          v-if="userForm.b2b_user"
          size="medium"
          type="primary"
          @click="openCreateModal()">Добавить продукт
        </el-button>
      <div v-for="(product, index) in products" :key="index">
        <!--<b>{{product.title}}</b>-->
        <div class="product-item">
          <div class="flex-space">
            <div>
              <b>Клиент</b>
              {{product.client.title}}
            </div>
            <el-button
              size="medium"
              type="danger"
              @click="beforeDeleteProduct(product.id)">
              <i class="el-icon-delete"></i>
            </el-button>
          </div>
            <br><br>
          <b>Конкуренты</b>
            <multiselect
              v-model="product.competitor"
              :multiple="true"
              track-by="id"
              label="title"
              :options="referencesList"
              placeholder="Выберите справочники"
              :max-height="150"
              :deselectLabel="$t('feed.audit.geo.multiselect.deselectLabel')"
              :selectLabel="$t('feed.audit.geo.multiselect.selectLabel')"
              :selectedLabel="$t('feed.audit.geo.multiselect.selectedLabel')"
            >
              <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong> is written in<strong>
              {{ option.id }}</strong></template>
            </multiselect>
            <br>
            <el-button @click="saveSelectCompetitor(product.competitor, product.id)">Сохранить</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="Добавить продукт" :visible.sync="modalCreateVisible">
        <!--<el-input v-model="newProduct"></el-input>-->
        <multiselect
              v-model="value"
              :multiple="false"
              track-by="id"
              label="title"
              :options="referencesList"
              placeholder="Выберите справочник"
              :max-height="150"
              :deselectLabel="$t('feed.audit.geo.multiselect.deselectLabel')"
              :selectLabel="$t('feed.audit.geo.multiselect.selectLabel')"
              :selectedLabel="$t('feed.audit.geo.multiselect.selectedLabel')"
            >
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong> </template>
        </multiselect>
        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="closeCreateModal(value)">Сохранить</el-button>
        </span>
    </el-dialog>
  </el-card>
</template>

<script>
  // components
  import notify from "../../../../helpers/notify";
  import Multiselect from 'vue-multiselect'

  // store
  import {CHANGE_USER, DELETE_USER} from "../../../../store/actions/users";
  import {mapGetters} from 'vuex';
  import {getReferencesApiListApi, getClientProductsApi, saveProductApi, getFullReferencesApi, linkReferenceToProductApi, deleteProductApi} from "../../../../api/references";
  import { iaoApi } from '../../../../helpers/iaoApi';

  export default {
    name: 'UserInfo',
    props: {
      user: {
        type: Object
      }
    },
    data() {
      return {
        value: null,
        modalVisible: false,
        modalCreateVisible: false,
        newProduct: '',
        userForm: {},
        maxThreadsOriginal: this.user.row.max_threads,
        apiList: [],
        firstProducts: [],
        products: [],
        referencesList: [],
        isIaoApi: false,
        roles: this.$t('user.roles'),
        rules: this.$t('user.rules'),
      };
    },
    computed: {
      ...mapGetters([
        'isAdmin',
      ]),
    },
    methods: {
      saveSelectCompetitor(competitor, id) {
        console.log("VALUR", competitor.map((it) => it.id))
        console.log("prod1", this.products.find((it) => it.id == id).competitor)
        console.log("prod2", this.firstProducts.find((it) => it.id == id).competitor)
        competitor.map((it) => {
          const params = {
            product_id: id,
            reference_item_id: it.id,
            reference_type: "competitor"
            }
          linkReferenceToProductApi(params).then((resp) => {
            console.log("linkReferenceToProduct", resp)
            this.getProducts()
          })
        })
      },

      saveSelectClient(client, id) {
          const params = {
            product_id: id,
            reference_item_id: client.id,
            reference_type: "client"
            }
          linkReferenceToProductApi(params).then((resp) => {
            console.log("linkReferenceToProduct", resp)
          })
      },
      openModal() {
        this.modalVisible = true;
        this.getProducts()
        this.loadReferences()
      },
      openCreateModal() {
        this.modalCreateVisible = true;
      },
      closeCreateModal(client) {
        this.modalCreateVisible = false;
        saveProductApi({uid: +this.userForm.uid, title: this.newProduct}).then((resp) => {
          console.log("save", resp)
          this.saveSelectClient(client, +resp.data.id)
          this.getProducts()
        })
      },
      handleDeleteProduct(id) {
        deleteProductApi({id: +id}).then(() => {
          notify.call(this, "Продукт удален", "success");
          this.getProducts()
        }).catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        });
      },

      getProducts() {
        getClientProductsApi({user_id: +this.userForm.uid}).then((resp) => {
          this.products = resp.data
          this.firstProducts = resp.data
        })
      },
      loadReferences() {
        const params = {}
        getFullReferencesApi(params).then((resp) => {
          let refs = []
          resp.data.slice(0,7).map((it)=> refs.push([...it.items]))
          var nums = refs[0].concat(refs[1], refs[2], refs[3], refs[4], refs[5], refs[6]);
          /*nums.map((it)=> it.name = it.keyword + " | id-" + it.id)*/
          let items = []
          nums.map((num) =>
            items.push({title: num.keyword + " | id-" + num.id, id: num.id })
          );
          this.referencesList = items;
        });
      },
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      handleIaoApi(value) {
        this.userForm.api_admin = value ? iaoApi() : 0
      },
      handleChangeThreads(value) {
        const maxThreadsLimit  = 65535;
        if (this.userForm.max_threads) {
          this.userForm.max_threads = parseInt(value);
          if (this.userForm.max_threads > maxThreadsLimit) {
            this.userForm.max_threads = maxThreadsLimit;
          }
        } else {
          this.userForm.max_threads = 0;
        }
      },
      handleEdit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.userForm.group = Number(this.userForm.group);

            if (this.userForm.max_threads == this.maxThreadsOriginal) {
              this.userForm.max_threads = null;
            }

            this.userForm.api_admin = this.isIaoApi ? iaoApi() : 0

            this.$store.dispatch(CHANGE_USER, this.userForm).then(() => {
              notify.call(this, "Пользователь сохранен", "success");
            }).catch(() => {
              notify.call(this, "Ошибка сервера", "error");
            });
          } else {
            notify.call(this, "Поля формы заполнены неверно", "error");
            return false;
          }
        });
      },
      beforeDeleteProduct(id) {
        this.$alert(`Удалить продукт?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.handleDeleteProduct(id);
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      beforeDelete(index, row) {
        this.$alert(`Удалить пользователя ${row.username}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.handleDelete();
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      handleDelete() {
        this.$store.dispatch(DELETE_USER, this.user.row.uid).then(() => {
          notify.call(this, "Пользователь удален", "success");
        }).catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        });
      },
    },
    beforeMount() {
      getReferencesApiListApi().then((resp) => {
        this.apiList = resp.data
      })
    },
    mounted() {
      console.log('iaoApi',iaoApi())
      this.maxThreadsOriginal = this.user.row.max_threads
      this.isIaoApi = this.user.row.api_admin === iaoApi()
      this.userForm = {...this.userForm, ...this.user.row, password: ''};
    },
    components: {
      Multiselect,
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .user-header {
    display: flex;
    justify-content: space-between;
  }
  .user-card-footer {
    display: flex;
    justify-content: space-between;
  }

  .product-btn{
    margin-left: 20px;
  }

  .product-item{
    border-bottom: 1px solid #c8c9cd;
    border-top: 1px solid #c8c9cd;
    margin: 10px;
    padding: 15px;
    background: #bfc7e83b;
  }

  .product-item ul{
    padding: 0 10px;
  }
  
  .flex-space{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  @media screen and (max-width: 480px) {
    .el-form-item.manage .el-form-item__content{
      margin-left: 0px!important;
    }
  }
</style>
